import Reveal from '@/components/base/Reveal';
import { leadsSystem } from '@/mocks/home';

export default function LeadsSystem() {
  return (
    <section id="leads-system" className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            The Framework
          </span>

          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            The L.E.A.D.S. System
          </h2>

          <p className="mt-4 text-foreground-600">
            Josh’s five-step growth framework for building a stronger marketing
            foundation, improving lead follow-up, dialing in paid acquisition,
            and scaling what works.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {leadsSystem.map((item, i) => (
            <Reveal key={item.letter} delay={i * 80}>
              <div className="h-full rounded-xl border border-white/8 bg-background-100 p-6 hover:border-primary-500/30 transition-colors">
                <div className="flex items-center justify-between">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400 font-heading font-extrabold text-xl">
                    {item.letter}
                  </span>

                  <span className="text-xs font-label font-semibold text-foreground-600">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>

                <h3 className="mt-5 font-heading font-semibold text-base text-foreground-950">
                  {item.title}
                </h3>

                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
